// Custom PropTypes validator to check if the value is an instance of window.Element
// but also falling back to Object if window is undefined (SSR).
const checkElementType = (props, propName, componentName) => {
    const instance = typeof window !== 'undefined' && window.Element ? window.Element : Object;
    if (props[propName] && !(props[propName] instanceof instance)) {
        return new Error(`Invalid prop '${propName}' supplied to '${componentName}'. Validation failed.`);
    }
    return null;
};

export {checkElementType};
